export default function configTrustedResources($sceDelegateProvider) {
  'ngInject';
  let whiteList = $sceDelegateProvider.resourceUrlWhitelist() || [];

  $sceDelegateProvider.resourceUrlWhitelist(whiteList.concat([
    // Trust Sulu images - this URL will probably need to change in the future
    'https://s3-us-west-2.amazonaws.com/sulu-content/images/**',
  ]));
}
